import EmptyImg from '../../../images/kick_avenue_empty_image.png';

export type TProductCategory =
  | 'sneakers'
  | 'streetwear'
  | 'fashion'
  | 'apparel'
  | 'luxury'
  | 'lifestyle'
  | 'apparels'
  | 'handbags'
  | 'lifestyles'
  | 'toys'
  | 'electronics-collectibles';

export type TImageType = TProductCategory | 'default';

type TProductCategoryValue =
  | 'sneakers'
  | 'apparels'
  | 'handbags'
  | 'lifestyles';

type TPlaceholderImageParam = TProductCategoryValue | 'default';

export const ProductCategory = {
  sneakers: 'sneakers' as TProductCategory,
  apparels: 'apparels' as TProductCategory,
  streetwear: 'apparels' as TProductCategory,
  fashion: 'apparels' as TProductCategory,
  apparel: 'apparels' as TProductCategory,
  handbags: 'handbags' as TProductCategory,
  luxury: 'handbags' as TProductCategory,
  lifestyles: 'lifestyles' as TProductCategory,
  lifestyle: 'lifestyles' as TProductCategory,
  toys: 'lifestyles' as TProductCategory,
  'electronics-collectibles': 'lifestyles' as TProductCategory,
};

export const PlaceholderImage = {
  sneakers: EmptyImg,
  apparels: EmptyImg,
  handbags: EmptyImg,
  lifestyles: EmptyImg,
  default: EmptyImg,
};

export const getProductCategory = (param: TProductCategory) => {
  return (ProductCategory[param] ||
    ProductCategory.sneakers) as TPlaceholderImageParam;
};

export const getPlaceholderImage = (param: TPlaceholderImageParam) => {
  return PlaceholderImage[param] || PlaceholderImage.sneakers;
};

export const getEmptyImage = (param: TImageType) => {
  if (param === 'default') {
    return getPlaceholderImage(param);
  }

  return getPlaceholderImage(getProductCategory(param));
};
